// @flow
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { VerticalLoadingBar } from 'components/atoms/verticalLoadingBar';
import squirrelIcon from 'assets/images/squirrel.svg';
import hamburgerIcon from 'assets/images/Hamburger-Menu-v3_Black-3.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  isMobile?: boolean,
  progress?: Number,
};

export const PageLoader = (props: Props) => {
  const { isMobile, progress: controlledProgress } = props;
  const [progress, setProgress] = useState(controlledProgress || 0);

  useEffect(() => {
    // Only auto-animate if no controlled progress is passed
    if (controlledProgress !== undefined) {
      setProgress(controlledProgress);
      return;
    }

    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) {
          clearInterval(interval);
          return prev;
        }
        return prev + Math.floor(Math.random() * 10 + 3);
      });
    }, 300);

    return () => clearInterval(interval);
  }, [controlledProgress]);


  const loaderClassNames = classNames('page-loader', {
    mobile: isMobile,
  });

  return (
    <>
      <div className={loaderClassNames}>
        <div className={'menu-icon-container'}>
          <div className={'menu-icon'}>
            <img
              className={'menu-icon-img'}
              src={hamburgerIcon}
              alt={'ham-menu'}
            />
          </div>
        </div>
        <div className={'content-container'}>
          <div className={'loading-bar-container'}>
            <VerticalLoadingBar progress={progress}/>
          </div>
        </div>
        <div className={'squirrel-icon-container'}>
          <img
            className={'squirrel-icon-img'}
            src={squirrelIcon}
            alt={'Total Environment Logo'}
          />
        </div>
      </div>
      <p className={'website-placeholder'}>
        <img src={squirrelIcon} alt={'Total Environment'} />
        <p className={'loading-percentage'}>Loading {Math.min(progress, 100)}%</p>
      </p>
    </>
  );
};
